import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";
import {commentSuccess} from "features/components/comment-field/reducer";
import {successCommentEdit} from "features/modals/comment-edit/reducer";
import {voteCommentSuccess} from "store/reducer/comments/vote/reducer";
import {startSingleThread} from "store/reducer/threads/single/reducer";

export const initialState = {
    status: ReducerStatuses.IDLE,
    error: "",
    data: {},
    current_page: 1,
    next_loading: false,
    metadata: {
        pages: 0,
        hasNext: false,
        totalItems: 0
    },
    type: null,
    resource_id: null,
    order_by: "chronological"
};

const slice = createSlice({
    name: "commentList",
    initialState,
    reducers: {
        getCommentsStart: (state, {payload}) => {
            state.status = ReducerStatuses.LOADING;
            state.error = "";
            state.type = payload.type;
            state.resource_id = payload.id;
        },
        getCommentsSuccess: (state, {payload}) => {
            state.status = ReducerStatuses.SUCCESS;
            if(state.current_page === 1) {
                state.data = payload.data;
            } else {
                state.data = {
                    ...state.data,
                    ...payload.data
                }
            }
            state.metadata = payload.metadata;
        },
        getCommentsFailure: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        getCommentsFetchNextPage: (state) => {
            state.current_page = state.current_page + 1;
            state.status = ReducerStatuses.LOADING;
        },
        setCommentsOrderBy: (state, {payload}) => {
            state.current_page = 1;
            state.status = ReducerStatuses.LOADING;
            state.order_by = payload;
        }
    },
    extraReducers: {
        [startSingleThread]: (state) => {
            state.status = ReducerStatuses.IDLE;
            state.current_page = 1;
            state.data = {}
        },
        [commentSuccess]: (state) => {
            state.current_page = 1;
            state.status = ReducerStatuses.LOADING;
        },
        [successCommentEdit]: (state) => {
            state.current_page = 1;
            state.status = ReducerStatuses.LOADING;
        },
        [voteCommentSuccess]: (state, {payload}) => {
            state.data[payload.comment_id].votes.voted = payload.vote;
            const total = state.data[payload.comment_id].votes.total;
            state.data[payload.comment_id].votes.total = payload.vote ? total + 1 : total - 1;
        }
    }
});

const {reducer, actions} = slice;

export const {
    getCommentsStart, getCommentsFailure, getCommentsFetchNextPage, getCommentsSuccess, setCommentsOrderBy
} = actions;

export default reducer;